import React, {Component} from 'react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import CrossfadeImage from 'react-crossfade-image';

import './LayerToggle.css';

@inject("appStore")
@observer
class LayerToggle extends Component {
    constructor(props){
        super(props);
        this.timeout = null;
        this.force = false;
    }
    // shouldComponentUpdate(nextProps){
    //     clearTimeout(this.timeout);
    //     this.force = false;
    //     if (nextProps.mode !== this.props.mode){
    //         this.force = true;
    //         this.forceUpdate();
    //     } else {
    //         this.timeout = setTimeout(() => {
    //             this.forceUpdate();
    //         }, 1000);
    //     }
    //     return false;
    // }
    // componentWillUnmount = () => {
    //     clearTimeout(this.timeout);
    // };
    render =()=> {
        let delay = (this.force) ? 100 : 2000;
        let duration = (this.force) ? 1000 : 1000;
        return (
            <div className={"LayerToggle " + this.props.appStore.inactiveMapMode }
                 onClick={() => {
                     this.props.appStore.toggleMapMode(); }
                 }>
                <span>{this.props.inactiveTitle}</span>
                <CrossfadeImage className={'InnerLayerToggle'}
                                src={this.props.inactiveStaticURL}
                                alt={this.props.appStore.inactiveMapMode}
                                delay={0}
                                duration={0}
                                timingFunction={"ease-out"}
                />
            </div>
        );
    }
}

export default LayerToggle;


// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/LayerToggle/index.js